(function () {
  if (window.ntProductInfoConsistencyLoaded) return;
  window.ntProductInfoConsistencyLoaded = true;

  var sectionHeading = /^(?:what(?:['\u2019]s| is) included(?: in the base kit)?|kit includes|optional accessories|compatible accessories|compatible accessory|recommended accessories|accessories|compatible products(?:\s*(?:&|and)\s*accessories)?|required for use|compatibility|features|key features|benefits|details|product details|specifications?|dimensions?|sizing|materials?|assembly|setup|how the plates work|how to use it|how to use|usage|care|maintenance|coverage|choose your mainline option)\s*:?$/i;
  var accessoryHeading = /^(?:optional accessories|compatible accessories|compatible accessory|recommended accessories|accessories|compatible products(?:\s*(?:&|and)\s*accessories)?)\s*:?$/i;
  var includedHeading = /^(?:what(?:['\u2019]s| is) included(?: in the base kit)?|kit includes)\s*:?$/i;

  function normalText(element) {
    return (element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isHeadingParagraph(p) {
    if (!p || p.tagName !== 'P') return false;
    var label = normalText(p);
    if (!sectionHeading.test(label)) return false;
    return !!p.querySelector('strong, b') || includedHeading.test(label);
  }

  function makeHeading(p) {
    p.classList.add('nt-info-heading');
    if (!p.querySelector('strong, b')) {
      var strong = document.createElement('strong');
      while (p.firstChild) strong.appendChild(p.firstChild);
      p.appendChild(strong);
    }
  }

  function canonicalizeAccessoryHeading(heading) {
    if (!accessoryHeading.test(normalText(heading))) return;
    var strong = heading.querySelector('strong, b');
    if (strong) {
      strong.textContent = 'OPTIONAL ACCESSORIES';
    } else {
      heading.textContent = 'OPTIONAL ACCESSORIES';
    }
  }

  function convertInlineIncluded(root) {
    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      if (!p.isConnected || !includedHeading.test(normalText(p))) return;
      if (!/<br\s*\/?>/i.test(p.innerHTML)) return;
      var pieces = p.innerHTML.split(/<br\s*\/?>/i);
      var intro = document.createElement('span');
      intro.innerHTML = pieces.shift() || '';
      if (!includedHeading.test(normalText(intro))) return;
      var lines = pieces.filter(function (part) {
        var check = document.createElement('span');
        check.innerHTML = part;
        return normalText(check).length > 0;
      });
      if (!lines.length) return;

      var heading = document.createElement('p');
      var label = document.createElement('strong');
      label.textContent = 'WHAT\u2019S INCLUDED';
      heading.appendChild(label);
      makeHeading(heading);

      var ul = document.createElement('ul');
      ul.className = 'nt-info-list';
      lines.forEach(function (line) {
        var li = document.createElement('li');
        var temp = document.createElement('span');
        temp.innerHTML = line;
        while (temp.firstChild) li.appendChild(temp.firstChild);
        ul.appendChild(li);
      });

      p.parentNode.insertBefore(heading, p);
      p.parentNode.insertBefore(ul, p);
      p.remove();
    });
  }

  function makeLinkedAccessoriesIntoList(heading) {
    if (!accessoryHeading.test(normalText(heading))) return;
    var next = heading.nextElementSibling;
    var matches = [];
    while (next && next.tagName === 'P' && !isHeadingParagraph(next)) {
      var link = next.querySelector('a[href*="/products/"]');
      if (!link) break;
      matches.push(next);
      next = next.nextElementSibling;
    }
    if (!matches.length) return;

    var ul = document.createElement('ul');
    ul.className = 'nt-info-list nt-info-accessories';
    heading.parentNode.insertBefore(ul, matches[0]);
    matches.forEach(function (p) {
      var li = document.createElement('li');
      while (p.firstChild) li.appendChild(p.firstChild);
      ul.appendChild(li);
      p.remove();
    });
  }

  function normalizeLists(root) {
    Array.prototype.slice.call(root.querySelectorAll('ul, ol')).forEach(function (list) {
      list.classList.add('nt-info-list');
    });
  }

  function markAccessoryLinks(heading) {
    if (!accessoryHeading.test(normalText(heading))) return;
    var next = heading.nextElementSibling;
    if (!next || (next.tagName !== 'UL' && next.tagName !== 'OL')) return;
    next.classList.add('nt-info-accessories');
    Array.prototype.slice.call(next.querySelectorAll('a[href*="/products/"]')).forEach(function (a) {
      if (a.closest('strong, b') || a.querySelector('strong, b')) return;
      var strong = document.createElement('strong');
      while (a.firstChild) strong.appendChild(a.firstChild);
      a.appendChild(strong);
    });
  }

  function normalizeTables(root) {
    Array.prototype.slice.call(root.querySelectorAll('table')).forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('nt-info-table-wrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'nt-info-table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  function normalize(root) {
    if (root.dataset.ntInfoNormalized === 'true') return;
    convertInlineIncluded(root);
    normalizeLists(root);
    normalizeTables(root);

    var headings = Array.prototype.slice.call(root.querySelectorAll('p')).filter(isHeadingParagraph);
    headings.forEach(makeHeading);
    headings.forEach(canonicalizeAccessoryHeading);
    headings.forEach(makeLinkedAccessoriesIntoList);
    normalizeLists(root);
    headings.forEach(markAccessoryLinks);

    root.dataset.ntInfoNormalized = 'true';
  }

  function run(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-nt-product-info]')) normalize(scope);
    Array.prototype.slice.call(scope.querySelectorAll('[data-nt-product-info]')).forEach(normalize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();